import { Controller } from "@hotwired/stimulus"
import { zipSync } from "fflate"

export default class extends Controller {
  static values = {
    files: Array, // array of { name: "filename.ext", url: "/path/to/file" }
    title: String,
  }

  connect() {
    console.log("attachment downloader connect")
  }

  async downloadZip() {
    const files = this.filesValue
    const zippedFiles = {}

    for (const file of files) {
      console.log(file.name)
      console.log(file.url)
      const response = await fetch(file.url)

      if (!response.ok) {
        console.error(`Failed to fetch ${file.url}`)
        continue
      }

      const arrayBuffer = await response.arrayBuffer()
      zippedFiles[file.name] = new Uint8Array(arrayBuffer)
    }

    const zipped = zipSync(zippedFiles)

    // Create download blob
    const blob = new Blob([zipped], { type: "application/zip" })
    const url = URL.createObjectURL(blob)

    console.log(url)

    const a = document.createElement("a")
    a.href = url
    a.download = `${this.titleValue || "files"}.zip`
    a.click()
    console.log(a)

    URL.revokeObjectURL(url)
  }
}
